<template>
  <section class="how-it-works">
    <div class="container">
      <h2 class="section-title">How It Works</h2>
      <p class="section-subtitle">Get started in three simple steps</p>

      <div class="steps-container">
        <!-- Step 1 -->
        <div class="step">
          <div class="step-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="7 10 12 15 17 10"/>
              <line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </div>
          <div class="step-number">1</div>
          <h3 class="step-title">Install Extension</h3>
          <p class="step-description">
            Add Cookie Cutter to your browser in just 30 seconds. Available for Chrome, Firefox, Safari, Edge, Brave, and Opera.
          </p>
        </div>

        <!-- Step 2 -->
        <div class="step">
          <div class="step-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="4" y1="21" x2="4" y2="14"/>
              <line x1="4" y1="10" x2="4" y2="3"/>
              <line x1="12" y1="21" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12" y2="3"/>
              <line x1="20" y1="21" x2="20" y2="16"/>
              <line x1="20" y1="12" x2="20" y2="3"/>
              <line x1="1" y1="14" x2="7" y2="14"/>
              <line x1="9" y1="8" x2="15" y2="8"/>
              <line x1="17" y1="16" x2="23" y2="16"/>
            </svg>
          </div>
          <div class="step-number">2</div>
          <h3 class="step-title">Set Your Preferences</h3>
          <p class="step-description">
            Choose your privacy preferences once. Decide which cookies to accept or reject automatically.
          </p>
        </div>

        <!-- Step 3 -->
        <div class="step">
          <div class="step-icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              <path d="M9 12l2 2 4-4"/>
            </svg>
          </div>
          <div class="step-number">3</div>
          <h3 class="step-title">Browse Cookie Banner-Free</h3>
          <p class="step-description">
            Enjoy the web without interruptions. Cookie Cutter handles all consent pop-ups automatically based on your preferences.
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "HowItWorks"
};
</script>

<style scoped>
.how-it-works {
  background-color: rgba(40, 54, 60, 0.5);
  backdrop-filter: blur(7px);
  filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
  padding: 60px 20px;
  margin-bottom: 0;
  position: relative;
  z-index: 1;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  text-align: center;
  color: #e8ae1b;
  font-size: clamp(32px, 4.5vw, 42px);
  font-weight: 700;
  margin: 0 0 12px 0;
}

.section-subtitle {
  text-align: center;
  color: rgba(254, 254, 254, 0.8);
  font-size: clamp(16px, 1.8vw, 18px);
  margin: 0 0 50px 0;
}

.steps-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 40px;
  position: relative;
  max-width: 1100px;
  margin: 0 auto;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 30px 20px;
  background: rgba(40, 54, 60, 0.6);
  border-radius: 16px;
  border: 2px solid rgba(232, 174, 27, 0.2);
  transition: all 0.3s ease;
  position: relative;
}

.step:hover {
  transform: translateY(-8px);
  border-color: rgba(232, 174, 27, 0.5);
  background: rgba(40, 54, 60, 0.8);
  box-shadow: 0 8px 24px rgba(232, 174, 27, 0.15);
}

.step-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, rgba(232, 174, 27, 0.2) 0%, rgba(232, 174, 27, 0.05) 100%);
  border-radius: 50%;
  margin-bottom: 20px;
  border: 2px solid rgba(232, 174, 27, 0.3);
  transition: all 0.3s ease;
}

.step:hover .step-icon {
  background: linear-gradient(135deg, rgba(232, 174, 27, 0.3) 0%, rgba(232, 174, 27, 0.1) 100%);
  border-color: rgba(232, 174, 27, 0.5);
  transform: scale(1.1);
}

.step-icon svg {
  width: 40px;
  height: 40px;
  color: #e8ae1b;
}

.step-number {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8ae1b;
  color: #182226;
  border-radius: 50%;
  font-weight: 700;
  font-size: 18px;
  box-shadow: 0 2px 8px rgba(232, 174, 27, 0.3);
}

.step-title {
  font-size: clamp(20px, 2.5vw, 24px);
  font-weight: 600;
  color: #fefefe;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.step-description {
  font-size: clamp(14px, 1.6vw, 16px);
  color: rgba(254, 254, 254, 0.8);
  line-height: 1.6;
  margin: 0;
}

@media (min-width: 900px) {
  .steps-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .how-it-works {
    padding: 40px 20px;
  }

  .section-subtitle {
    margin-bottom: 40px;
  }

  .steps-container {
    gap: 30px;
  }

  .step {
    padding: 25px 20px;
  }

  .step-number {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }
}

@media (max-width: 500px) {
  .how-it-works {
    padding: 30px 16px;
  }

  .step-icon {
    width: 70px;
    height: 70px;
  }

  .step-icon svg {
    width: 35px;
    height: 35px;
  }
}
</style>
